import { render, staticRenderFns } from "./ConsumptionConfig.vue?vue&type=template&id=397863ee&scoped=true"
import script from "./ConsumptionConfig.vue?vue&type=script&lang=js"
export * from "./ConsumptionConfig.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionConfig.vue?vue&type=style&index=0&id=397863ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397863ee",
  null
  
)

export default component.exports